<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="wasteAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="wasteAddEditForm.get('waste')?.value || wasteAddEditForm.get('region')?.value"
              class="sub-header-drpdown pb-2"
              >Waste</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #waste
              [items]="processingWasteList"
              [searchable]="false"
              bindValue="id"
              bindLabel="name"
              formControlName="waste"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Waste *"
              groupBy="childItems"
              (change)="onChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="waste.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted || wasteAddEditForm.controls['waste']?.touched"
              class="input-error"
            >
              <div *ngIf="wasteAddEditForm.controls['waste']?.invalid">
                The waste field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="wasteAddEditForm.get('waste')?.value || wasteAddEditForm.get('region')?.value"
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionData"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="region.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (wasteAddEditForm.controls['region']?.touched &&
                  wasteAddEditForm.controls['region']?.invalid) ||
                wasteAddEditForm.controls['region'].value?.name === '--Select Region-- ' ||
                (submitted && !wasteAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="wasteForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                [formControlName]="formData.name"
                type="number"
                maxlength="30"
                class="input-custom-style"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="{{ formData.name }} ({{ formData.unit }})"
              />
              <label>{{ formData.name }} ({{ formData.unit }})</label>
              <div *ngIf="submitted && wasteForm.get(formData.name)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="submitted && (this.wasteAddEditForm.invalid || wasteForm.invalid)"
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span>To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (wasteAddEditForm.controls['waste']?.touched || submitted) &&
                    wasteAddEditForm.controls['waste']?.invalid
                  "
                >
                  Waste
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (wasteAddEditForm.controls['region']?.touched &&
                      wasteAddEditForm.controls['region']?.invalid) ||
                    wasteAddEditForm.controls['region'].value?.name === '--Select region-- ' ||
                    (submitted && !wasteAddEditForm.controls['region'].value?.name)
                  "
                >
                  Region
                </div>
              </div>
              <div class="topBottomCss" *ngIf="wasteForm.invalid">
                <div>Default value</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
